export default __webpack_public_path__ + "static/media/Equity.2232d078.svg";